import React from "react";

export default function PublicOffer() {
  return (
    <div style={{ backgroundColor: "#000", color: "#fff", fontFamily: "sans-serif", padding: "40px 20px", minHeight: "100vh" }}>
      <div style={{ maxWidth: "900px", margin: "0 auto", fontSize: "10pt" }}>
        <h1 style={{ fontSize: "32px", marginBottom: "20px" }}>Публічна оферта</h1>
       <p style={{ marginBottom: "16px" }}>UAB AutoliderLT (торгова марка Autopodbor.lt)</p>
<p style={{ marginBottom: "16px" }}>Įmonės kodas: 306990900</p>
<p style={{ marginBottom: "16px" }}>Adresas: V. Nagevičiaus g. 3, LT-08237 Vilnius</p>
<p style={{ marginBottom: "16px" }}>Telefonas: +37061744495</p>
<p style={{ marginBottom: "24px" }}>Дата публікації оферты: 17.05.2025</p>


        <div style={{ lineHeight: "1.6" }}>
  <h2>1. Загальні положення</h2>
  <p>1.1. Ця Оферта є офіційною пропозицією укласти договір про надання платних послуг.</p>
  <p>1.2. Оферта не потребує підписання в паперовій формі та має юридичну силу відповідно до Цивільного кодексу Литовської Республіки.</p>
  <p>1.3. Замовлення послуг означає повне та безумовне прийняття всіх умов Оферти.</p>
  <p>1.4. Послуги надаються виключно з інформаційно-консультаційною метою.</p>
  <p>1.5. Виконавець не є продавцем автомобілів і не несе відповідальності за дії третіх осіб.</p>

  <h2>2. Предмет оферти</h2>
  <p>2.1. Виконавець надає послуги з підбору, діагностики, консультування, перевірки та супроводу купівлі автомобілів.</p>
  <p>2.2. Обсяг послуг визначається обраним Замовником пакетом на сайті Autopodbor.lt.</p>
  <p>2.3. Послуги можуть надаватися дистанційно або особисто.</p>
  <p>2.4. Вся комунікація здійснюється через електронну пошту, месенджери, телефон або сайт.</p>
  <p>2.5. Послуги вважаються наданими після надання звіту/виконання дій згідно з пакетом.</p>

  <h2>3. Права та обов’язки сторін</h2>
  <p>3.1. Виконавець зобов'язується:</p>
  <p>– Надавати послуги якісно, вчасно, з дотриманням заявленого обсягу.</p>
  <p>– Інформувати Замовника про знайдені варіанти, результати діагностики та хід робіт.</p>
  <p>– Дотримуватись конфіденційності отриманої інформації.</p>
  <p>3.2. Виконавець має право:</p>
  <p>– Відмовити у наданні послуг без пояснення причин до моменту оплати.</p>
  <p>– Припинити надання послуг у разі порушення Замовником умов Оферти.</p>
  <p>– Самостійно приймати рішення про відхилення сумнівних варіантів авто.</p>
  <p>3.3. Замовник зобов’язується:</p>
  <p>– Надати коректну інформацію та вимоги.</p>
  <p>– Оплатити обраний пакет послуг до початку робіт.</p>
  <p>– Підтримувати зв’язок та оперативно відповідати на повідомлення.</p>
  <p>3.4. Замовник має право:</p>
  <p>– Отримувати консультації в процесі підбору.</p>
  <p>– Підвищити пакет послуг, доплативши різницю.</p>
  <p>– Припинити співпрацю (див. розділ 6).</p>

  <h2>4. Порядок надання послуг</h2>
  <p>4.1. Роботи починаються після 100% передоплати обраного пакету.</p>
  <p>4.2. Підбір здійснюється протягом строків, вказаних в описі послуг (зазвичай від 1 до 15 робочих днів), максимум — 30 робочих днів.</p>
  <p>4.3. У разі подовження строків Виконавець повідомляє Замовника.</p>
  <p>4.4. У межах пакету надаються звіти, фото, відео та рекомендації.</p>
  <p>4.5. Рішення про купівлю автомобіля приймає сам Замовник.</p>
  <p>4.6. Після завершення обраного етапу послуги вважаються наданими.</p>

  <h2>5. Відповідальність сторін</h2>
  <p>5.1. Виконавець несе відповідальність лише за послуги в межах обраного пакету.</p>
  <p>5.2. Виконавець не гарантує відсутність прихованих дефектів у авто.</p>
  <p>5.3. Виконавець не несе відповідальності за рішення Замовника щодо купівлі.</p>
  <p>5.4. Замовник несе відповідальність за свої дії після отримання рекомендацій.</p>
  <p>5.5. Ризики, пов’язані з подальшою реєстрацією, ремонтом, використанням авто, лежать на Замовнику.</p>
  <p>5.6. Викуп авто здійснюється Виконавцем за дорученням та коштом Замовника. Передача коштів продавцю здійснюється виключно з коштів, наданих Замовником.</p>
  <p>5.7. У разі експорту авто до іншої країни, усі митні збори, податки, мита, реєстраційні та інші обов’язкові платежі сплачуються Замовником самостійно або через Виконавця, за умови попереднього надання відповідних коштів. Виконавець не несе відповідальності за затримки, відмови або дії митних чи інших державних органів країни призначення.</p>

  <h2>6. Фінансові умови та повернення</h2>
  <p>6.1. Оплата послуг здійснюється безготівково або переказом, якщо інше не погоджено із Замовником.</p>
  <p>6.2. У разі припинення підбору з ініціативи Замовника повернення коштів можливе лише з урахуванням обсягу вже виконаних робіт.</p>
  <p>6.3. Повернення здійснюється протягом 14 робочих днів після письмового запиту.</p>
  <p>6.4. Пакети не підлягають поверненню, якщо послуги були надані повністю.</p>
  <p>6.5. Підвищення пакету здійснюється шляхом доплати різниці.</p>
  <p>6.6. У разі відмови від купівлі рекомендованого авто повторний підбір оплачується окремо.</p>

  <h2>7. Відмова від відповідальності</h2>
  <p>7.1. Виконавець оцінює технічний та візуальний стан авто виключно на момент його огляду та діагностики в межах обраного пакету. Уся виявлена інформація добросовісно відображається у звіті. Виконавець не несе відповідальності за зміни, які можуть відбутись з авто після перевірки, включаючи технічні несправності, втручання третіх осіб або наслідки експлуатації. Рішення про купівлю авто Замовник приймає самостійно на основі наданих даних.</p>
  <p>7.2. Виконавець не є продавцем і не отримує комісію від продажу.</p>
  <p>7.3. Виконавець не гарантує успішну реєстрацію авто в іншій країні.</p>
  <p>7.4. Усі висновки мають рекомендаційний характер.</p>
  <p>7.5. У разі відмови Замовника слідувати рекомендаціям Виконавець відповідальності не несе.</p>

  <h2>8. Форс-мажор</h2>
  <p>8.1. Сторони звільняються від відповідальності у разі настання обставин непереборної сили (форс-мажору).</p>
  <p>8.2. До таких обставин належать: війна, стихійні лиха, епідемії, блокування рахунків, дії держорганів тощо.</p>
  <p>8.3. Строки виконання зобов’язань переносяться на період дії форс-мажору.</p>

  <h2>9. Конфіденційність</h2>
  <p>9.1. Усі дані, передані Замовником, використовуються виключно для виконання замовлення.</p>
  <p>9.2. Виконавець не передає інформацію третім особам без згоди Замовника.</p>
  <p>9.3. Відгуки, фото та відео можуть використовуватись у портфоліо лише за погодженням.</p>

  <h2>10. Заключні положення</h2>
  <p>10.1. Ця Оферта діє безстроково та може бути змінена без попереднього повідомлення.</p>
  <p>10.2. Усі спори вирішуються шляхом переговорів, у разі неможливості — згідно із законодавством Литви.</p>
  <p>10.3. Факт оплати послуг підтверджує згоду з Офертою.</p>
  <p>10.4. Електронне листування, месенджери та документи мають юридичну силу.</p>
  <p>10.5. Усі умови, що прямо не прописані, регулюються в межах стандартного договору про надання послуг.</p>
</div>
      </div>
    </div>
  );
}
